export const addSpaceBeforeCapitalLetters = (value?: string | null) =>
  value ? value.replace(/([A-Z]+)/g, ' $1').trim() : '';

export const isEmptyObject = (obj: any) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};
